module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8dn8C"))).then(() => parcelRequire('1iHdE'));